import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

document.addEventListener('DOMContentLoaded', function () {
  const splide = new Splide('.splide', {
    arrows: true,
  });
  splide.mount();
});
